import React from "react";
import { Link } from "react-router-dom";
import { FaDiscord } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";
import { TbBrandInstagramFilled } from "react-icons/tb";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
export default function Footer() {
  return (
    <section className="relative mt-28 pb-5 px-4 z-[999]">
      <div className="container">
        <div className="flex flex-col items-center md:flex-row justify-between w-full text-white">
          {/* Left side */}
          <div
            className="flex gap-x-1 items-center pl-4"
            style={{ direction: "rtl" }}
          >
            <IoShieldCheckmarkSharp className="w-6 h-6 text-gray-500 " />
            <span className="text-gray-500">پرداخت امن با</span>
            <div className="flex items-center gap-x-5 mr-3 child:cursor-pointer">
              <img src="./images/zarinpal.webp" alt="" className="w-8 h-8" />
              <img src="./images/enamad.webp" alt="" className="w-8 h-8" />
              <img src="./images/samandehi.webp" alt="" className="w-8 h-8" />
            </div>
          </div>

          {/* Right side */}
          <div className="flex flex-col md:flex-row gap-x-7 gap-y-7 items-center mt-7">
            {/* Social Icons */}
            <div style={{ direction: "rtl" }}>
              <a
                href=""
                className="group w-10 h-10 bg-lighterGray border border-gray-700 inline-flex justify-center items-center rounded-xl transition-colors hover:bg-[#D4FE00] hover:text-black"
              >
                <FaDiscord className="w-6 h-6 text-gray-500 group-hover:text-black transition-colors" />
              </a>
              <a
                href=""
                className="group w-10 h-10 bg-lighterGray border border-gray-700 inline-flex justify-center items-center rounded-xl transition-colors hover:bg-[#D4FE00] hover:text-black mr-2"
              >
                <FaTelegramPlane className="w-6 h-6 text-gray-500 group-hover:text-black transition-colors" />
              </a>
              <a
                href=""
                className="group w-10 h-10 bg-lighterGray border border-gray-700 inline-flex justify-center items-center rounded-xl transition-colors hover:bg-[#D4FE00] hover:text-black mr-2"
              >
                <TbBrandInstagramFilled className="w-6 h-6 text-gray-500 group-hover:text-black transition-colors" />
              </a>
            </div>

            {/* Logo*/}
            <div className="max-w-[141px]" style={{ direction: "rtl" }}>
              <Link to="/">
                <img
                  src="./images/trexmine.png"
                  alt=""
                  className="w-full h-full"
                />
              </Link>
              <h3>© 1403 تیرکس ماین</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
